import { render, staticRenderFns } from "./SaldonTilaus.vue?vue&type=template&id=30805a20&"
import script from "./SaldonTilaus.vue?vue&type=script&lang=js&"
export * from "./SaldonTilaus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports